export default __webpack_public_path__ + "static/media/big_banner_highlight.4f3b9412.png";